import { FormattedMessage, useIntl } from "react-intl";

import type { TooltipProps } from "@citrine/atoms/tooltip";
import type { TranslationID } from "@citrine/lang/utils";

import * as sx from "./info-tooltip.sx";

type InfoTooltipProps = Omit<
  React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLSpanElement>,
    HTMLSpanElement
  >,
  "title"
> & {
  placement?: TooltipProps["placement"];
  headerId?: TranslationID;
  "data-testid"?: string;
} & (
    | {
        title: React.ReactElement;
        id?: undefined;
      }
    | {
        title?: undefined;
        id: TranslationID;
      }
  );

export function InfoTooltip({
  placement = "top",
  title,
  id,
  headerId,
  "data-testid": dataTestId,
}: InfoTooltipProps) {
  const { formatMessage } = useIntl();

  const tooltipBody = id
    ? formatMessage({ id }, { p: (content) => <p>{content}</p> })
    : title;

  const tooltipContent = (
    <>
      {headerId ? (
        <sx.Header>
          <FormattedMessage id={headerId} />
        </sx.Header>
      ) : null}
      <div>{tooltipBody}</div>
    </>
  );

  return (
    <sx.Tooltip placement={placement} title={tooltipContent ?? ""}>
      <sx.InfoIcon data-testid={dataTestId} fontSize="small" />
    </sx.Tooltip>
  );
}
